import { render, staticRenderFns } from "./home-delivery-world-2026-banner.vue?vue&type=template&id=35394b2d&scoped=true&"
import script from "./home-delivery-world-2026-banner.vue?vue&type=script&lang=js&"
export * from "./home-delivery-world-2026-banner.vue?vue&type=script&lang=js&"
import style0 from "./home-delivery-world-2026-banner.vue?vue&type=style&index=0&id=35394b2d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35394b2d",
  null
  
)

export default component.exports